import { z } from "zod";

export const advanceFilterSchema = z.object({
  title: z.string().optional(),
  created_at_after: z.string().optional(),
  created_at_before: z.string().optional(),
  ad_type: z.string().nullable().optional(),
  listing_type: z.string().nullable().optional(),
  property_type: z.string().nullable().optional(),

  min_year_built: z.string().optional(),
  max_year_built: z.string().optional(),

  min_price: z.string().optional(),
  max_price: z.string().optional(),

  min_mortgage_amount: z.string().optional(),
  max_mortgage_amount: z.string().optional(),

  min_rent_amount: z.string().optional(),
  max_rent_amount: z.string().optional(),

  min_area: z.string().optional(),
  max_area: z.string().optional(),
  floor: z.string().optional(),
  area: z.string().optional(),
});

export type AdvanceFilterFormValues =
  z.infer<typeof advanceFilterSchema>;
